export default "__VITE_ASSET__CRPhS9KT__"